import React from "react";
//Icons
import {appHelpers} from "../../_helpers";
import { Table, Th, Thead, Tr, Td } from 'reactable';


const UnmatchedPaymentTableStructure = ({data}) =>  {
        return (
            <div>
            <Table className="table table-striped table-hover" id="table" sortable={true} itemsPerPage={10} pageButtonLimit={10}>
                <Thead>
                    <Th column="Created">
                        <span>Created Date</span>
                    </Th>
                    <Th column="Invoice">
                        <span>Invoice Number</span>
                    </Th>
                    <Th column="Payment">
                        <span>Payment Date</span>
                    </Th>
                    <Th column="Action">
                        <span>Description</span>
                    </Th>
                </Thead>
                {data.map((item, i) => <Tr key={i}>
                <Td column="Created" className="text-capitalize">{appHelpers.formatDate(item.CreatedDate)}</Td>
                <Td column="Invoice" className="text-capitalize">{ (item.InvoiceNumber) }</Td>
                <Td column="Payment" className="text-capitalize">{appHelpers.formatDate(item.PaymentDate)}</Td>
                <Td column="Action" className="text-capitalize">Incorrect Invoice Number </Td>
                    </Tr>)}
            </Table>
            </div>
        )
}

class UnmatchedRecords extends React.Component {
    render() {
        let { data } = this.props;
        return (
            <div>
                <UnmatchedPaymentTableStructure data={data}/>
            </div>
        )
    }
}
export default UnmatchedRecords;



// WEBPACK FOOTER //
// ./src/views/unmatched-domestic-payment/unmatched-records.js